import * as Yup from 'yup';
import { LockerVendor } from '../entities/locker.entity';

export interface LockerForm {
  lockerId?: string;
  condominiumId?: string;
  vendor?: LockerVendor;
}

export type LockerFormShape = {
  [key in keyof LockerForm]?: any;
};

export const schema = Yup.object().shape<LockerFormShape>({
  condominiumId: Yup.string().required('É necessário selecionar o condomínio'),
  lockerId: Yup.string().required('É necessário informar o id do locker no parceiro'),
  vendor: Yup.string().required('É necessário preencher o parceiro desse armário'),
});
